import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]
  static values = {
    startedAt: String,
    targetHours: Number
  }

  connect() {
    this.updateDisplay()
    this.interval = setInterval(() => this.updateDisplay(), 1000)
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  updateDisplay() {
    const startedAt = new Date(this.startedAtValue)
    const now = new Date()
    const diffMs = now - startedAt

    const hours = Math.floor(diffMs / (1000 * 60 * 60))
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diffMs % (1000 * 60)) / 1000)

    const display = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`

    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = display

      // Change color when target is reached
      const targetMs = this.targetHoursValue * 60 * 60 * 1000
      if (diffMs >= targetMs) {
        this.displayTarget.classList.remove("text-gray-900")
        this.displayTarget.classList.add("text-emerald-600")
      }
    }
  }

  pad(num) {
    return num.toString().padStart(2, "0")
  }
}
